import { STYLE_TYPE, SHOW_TYPE_ENUM, LOAD_MORE_TYPE } from './types/common';
export { STYLE_TYPE, SHOW_TYPE_ENUM, LOAD_MORE_TYPE };
export var DETAIL_PAGE_ANCHOR;
(function (DETAIL_PAGE_ANCHOR) {
    DETAIL_PAGE_ANCHOR["NONE"] = "none";
    DETAIL_PAGE_ANCHOR["GOODS"] = "goods";
    DETAIL_PAGE_ANCHOR["MULTI"] = "multi";
})(DETAIL_PAGE_ANCHOR || (DETAIL_PAGE_ANCHOR = {}));
export var GOODS_STATUS;
(function (GOODS_STATUS) {
    GOODS_STATUS[GOODS_STATUS["CAN_SALE"] = 1] = "CAN_SALE";
    GOODS_STATUS[GOODS_STATUS["CAN_NOT_SALE"] = 2] = "CAN_NOT_SALE";
})(GOODS_STATUS || (GOODS_STATUS = {}));
export var GOODS_TYPE;
(function (GOODS_TYPE) {
    GOODS_TYPE[GOODS_TYPE["DEAL"] = 3] = "DEAL";
    GOODS_TYPE[GOODS_TYPE["TONG_DUI"] = 6] = "TONG_DUI";
    GOODS_TYPE[GOODS_TYPE["SUPER_GROUP"] = 11] = "SUPER_GROUP";
})(GOODS_TYPE || (GOODS_TYPE = {}));
